// extracted by mini-css-extract-plugin
export var background = "layout-module--background--e2d09";
export var ellipse1 = "layout-module--ellipse1--70582";
export var ellipse1Mobile = "layout-module--ellipse1Mobile--e0ce1";
export var ellipse2 = "layout-module--ellipse2--d6be4";
export var ellipse2Mobile = "layout-module--ellipse2Mobile--a125a";
export var menu = "layout-module--menu--c145d";